
import Vue from "vue";
import { Component, Prop, PropSync } from "vue-property-decorator";
import SubscriptionEntry from "@/models/subscription/SubscriptionEntry";
import SubscriptionPlan from "@/models/subscription/SubscriptionPlan";
import HideShowOptionView from "@/components/general/HideShowOptionView.vue";
import UpdateIndicator from "@/components/general/UpdateIndicator.vue";

@Component({
  components: { HideShowOptionView, UpdateIndicator },
})
export default class AppBar extends Vue {
  // 🚩 Flag for whether the navigation drawer should be visible or not
  @PropSync("drawerIsOpen")
  public drawer!: boolean;

  // 🚩 Flag for whether the dashboard name icon should be shown
  private showEditNameIcon: boolean = false;

  private get isDesktop(): boolean {
    return !this.$vuetify.breakpoint.mobile;
  }

  // 📦 Page title whenver the web app is displayed on mobile device
  private get mobilePageTitle(): string | undefined | null {
    if (this.$route.fullPath.includes("settings")) {
      return "Settings";
    }
    if (this.$route.fullPath.includes("stats")) {
      return "Statistics";
    }
    if (this.$route.name === "Dashboard") {
      return "Hello ";
    }
    return this.$route.name;
  }

  // 📦 The user name of the current user
  private get username(): string {
    return this.$store.state.userData.username;
  }

  // 📦 The current subscription limitations
  private get currentSubscriptionPlan(): SubscriptionPlan {
    return this.$store.state.subscription.currentSubscriptionPlan;
  }

  // 📦 The current Stripe subscription
  private get currentStripeSubscription(): SubscriptionEntry {
    return this.$store.state.payments.currentSubscription;
  }

  // 📦 The number of unread notifications the current user has
  private get unreadNotifications(): number | null {
    if (
      this.$store.state.notifications.unreadNotifications === undefined ||
      this.$store.state.notifications.unreadNotifications.all == 0
    ) {
      return null;
    }
    return this.$store.state.notifications.unreadNotifications.all;
  }

  // 📦 The name of the subscription the current user is on (if Stripe is available - it has priority)
  private get currentSubscriptionPlanName(): string | null {
    if (
      this.currentStripeSubscription !== undefined &&
      this.currentStripeSubscription != null
    ) {
      return this.currentStripeSubscription.productName;
    }
    return this.currentSubscriptionPlan.type + " Plan";
  }

  /**
   * 🚪 Functionality that cleans the current Vuex state and redirects the user to login page
   */
  private async logout() {
    await this.$store.dispatch("prepareUserForLogout");
    this.$router.push("/login");
  }

  /**
   * 🔃 Reloads the current page if the user is on the create bot page
   */
  private reloadPage() {
    window.location.reload();
  }
}
